import React, { createContext, Suspense, useEffect } from "react";
import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login/Login";
import Dashboard from "./components/Dashboard/Dashboard";
import Details from "./components/Details/Details";
import Report from "./components/OutdoorDuties/Report";
import { ProtectedRoutes } from "./route/ProtectedRoutes";
// import Client from "./components/Clients/Client";
import ScheduledMeting from "./components/ScheduledMetting/ScheduledMeting";
import ExpenseList from "./components/Expense/ExpenseList";
import CompanyPermissions from "./components/CompanyPermission/CompanyPermission";
import DetailsData from "./components/Details/DetailsData";
import ConfiguartionUpdate from "./components/ConfiguartionDeatils/ConfiguartionUpdate";
import Setup from "./components/CustomeForm/Setup";
import CreateDynamiceForm from "./components/CustomeForm/CreateDynamiceForm";
import Preview from "./components/CustomeForm/Preview/Preview";
import CreateClientDetails from "./components/CustomeForm/CreateClientDetails";
import AddHeader from "./components/CustomeForm/AddHeader/AddHeader";
import ShowAttendanceView from "./components/Show Attendance View/ShowAttendanceView";
import LiveTracking from "./components/Tracking/live";
import Users from "./components/users/Users";
import OdRestoreEmployee from "./components/OutdoorDuties/OdRestoreEmployee";
import VehicleType from "./components/Masters/VehicleType/VehicleType";

const ClientsList = React.lazy(() => import("./components/Clients/Client"));
const AddClient = React.lazy(() => import("./components/Clients/AddClient"));
const UpdateClient = React.lazy(
  () => import("./components/Clients/UpdateClient"),
);
const PermissionMasterConfig = React.lazy(
  () => import("./components/PermissionMasterConfig/PermissionMasterConfig"),
);

const ClientDynamicFormTemplateList = React.lazy(
  () => import("./components/CustomeForm/ClientDynamicFormTemplateList"),
);

const GeofenceList = React.lazy(
  () => import("./components/GeofenceManagement/GeofenceList"),
);

const CreateGeofence = React.lazy(
  () => import("./components/GeofenceManagement/CreateGeofence"),
);

export const themeContext = createContext({ color: "#542f85" });

function App() {
  useEffect(() => {
    document.title = window.location.hostname.includes("nyggs")
      ? "Nyggs SFA"
      : "SFA";

    let metaDescription = document.querySelector('meta[name="description"]');
    metaDescription.content = window.location.hostname.includes("nyggs")
      ? "Powered by Nyggs ERP"
      : "Powered by SFA";
  }, []);
  return (
    <div className="App">
      {/* <Header /> */}
      <Suspense fallback={<div>Loading</div>}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/DetailsData/:id" element={<DetailsData />} />

          {/* <Routerr /> */}
          <Route element={<ProtectedRoutes />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/details/:id" element={<Details />} />
            <Route path="/live/:id?" element={<LiveTracking />} />

            <Route path="/outdoorduties/:id?" element={<Report />} />
            <Route path="/client" element={<ClientsList />} />
            <Route path="/addClient" element={<AddClient />} />
            <Route path="/updateClient/:clientId" element={<UpdateClient />} />
            <Route path="/scheduledMeting" element={<ScheduledMeting />} />
            <Route path="/expenseList" element={<ExpenseList />} />
            <Route path="/companyDetails" element={<CompanyPermissions />} />
            <Route
              path="/companywiseclient"
              element={<ConfiguartionUpdate />}
            />
            <Route
              path="/CreateMettingDetails"
              element={<CreateDynamiceForm />}
            />
            <Route
              path="/clientDynamicFormTemplateList"
              element={<ClientDynamicFormTemplateList />}
            />
            <Route
              path="/CreateDynamiceForm/:id"
              element={<CreateClientDetails />}
            />
            <Route path="/AddHeader/:id" element={<AddHeader />} />
            <Route path="/customeForm/:id" element={<Setup />} />
            <Route path="/Preview" element={<Preview />} />
            <Route
              path="/ShowAttendanceView"
              element={<ShowAttendanceView />}
            />
            {/* <Route
              path="/permissionMasterConfig"
              element={<PermissionMasterConfig />}
            /> */}
            <Route path="/users" element={<Users />} />
            <Route path="/OdRestoreEmployee" element={<OdRestoreEmployee />} />
            <Route path="/geofenceList" element={<GeofenceList />} />
            <Route
              path="/createGeofence/:geofenceId?"
              element={<CreateGeofence />}
            />
            <Route path="/vehicleType" element={<VehicleType />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
